(() => {
  const DEFAULT_FREE_SHIPPING_THRESHOLD = 115;

  const SELECTORS = {
    cartForm: "form#cart",
    footer: "#main-cart-footer",
    subtotal: "#main-cart-footer .totals__total-value",
    bar: "[data-free-shipping-threshold]",
    message: "[data-free-shipping-message]",
    progress: "[data-free-shipping-progress]",
  };

  let observer = null;

  function parseMoney(text) {
    if (!text) return null;

    const cleaned = text
      .replace(/\s+/g, "")
      .replace(/[^\d.,]/g, "");

    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");

    let normalized = cleaned;

    if (hasComma && hasDot) {
      normalized = cleaned.replace(/,/g, "");
    } else if (hasComma && !hasDot) {
      normalized = cleaned.replace(",", ".");
    }

    const value = parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function getScopedElements() {
    const cartForm = document.querySelector(SELECTORS.cartForm);
    if (!cartForm) return null;

    const messageEl = cartForm.querySelector(SELECTORS.message);
    const progressEl = cartForm.querySelector(SELECTORS.progress);

    if (!messageEl || !progressEl) return null;

    return { messageEl, progressEl };
  }

  function getSubtotal() {
    const el = document.querySelector(SELECTORS.subtotal);
    return el ? parseMoney(el.textContent) : null;
  }

  function getThreshold() {
    const barEl = document.querySelector(SELECTORS.bar);
    const value = barEl ? parseFloat(barEl.dataset.freeShippingThreshold) : NaN;
    return Number.isFinite(value) && value > 0
      ? value
      : DEFAULT_FREE_SHIPPING_THRESHOLD;
  }

  function updateBar() {
    const scoped = getScopedElements();
    if (!scoped) return;

    const { messageEl, progressEl } = scoped;

    const barEl = messageEl.closest(".relative.overflow-hidden");
    if (barEl) {
      barEl.style.marginBottom = "15px";
    }

    const subtotal = getSubtotal();

    // Marking the node instead of a module variable keeps this in sync with a
    // re-rendered cart form.
    const applied = String(subtotal);
    if (messageEl.dataset.freeShippingApplied === applied) return;
    messageEl.dataset.freeShippingApplied = applied;

    const threshold = getThreshold();

    if (!subtotal || subtotal <= 0) {
      messageEl.textContent = `Free Delivery on orders £${threshold}+`;
      progressEl.style.width = "0%";
      return;
    }

    const remaining = Math.max(threshold - subtotal, 0);
    const progress = Math.min((subtotal / threshold) * 100, 100);

    messageEl.textContent =
      remaining === 0
        ? "You’ve unlocked free shipping 🎉"
        : `You’re £${remaining.toFixed(2)} away from free shipping.`;

    progressEl.style.width = `${progress}%`;
  }

  function observeFooter() {
    const footer = document.querySelector(SELECTORS.footer);
    if (!footer) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      updateBar();
    });

    observer.observe(footer, {
      childList: true,
      subtree: true,
    });

    updateBar();
  }

  document.addEventListener("DOMContentLoaded", observeFooter);
})();
